
import { useEffect } from "react";

interface AddressValidationProps {
  collectionAddress: {
    street: string;
    city: string;
    province: string;
    postalCode: string;
    country: string;
  };
  deliveryAddress: {
    street: string;
    city: string;
    province: string;
    postalCode: string;
    country: string;
  };
  onValidationChange?: (isValid: boolean) => void;
}

export const useAddressValidation = ({ 
  collectionAddress, 
  deliveryAddress, 
  onValidationChange 
}: AddressValidationProps) => {
  const validateAddresses = (
    collection: typeof collectionAddress, 
    delivery: typeof deliveryAddress
  ) => {
    const isValid = Boolean(
      collection.street && collection.city && collection.province && collection.postalCode && collection.country &&
      delivery.street && delivery.city && delivery.province && delivery.postalCode && delivery.country
    );
    onValidationChange?.(isValid);
    return isValid;
  };

  useEffect(() => {
    validateAddresses(collectionAddress, deliveryAddress);
  }, [collectionAddress, deliveryAddress, onValidationChange]);

  return { validateAddresses };
};
